<template>
    <div class="guide-header-items">
        <local-app-chooser
            v-model="selectedAppId"
            :exclude-groups="true"
            :trigger-size="'mini'"
            :filter-non-integrated-apps="true"
            @input="handleAppChange" />
        <pendo-button
            type="subtle"
            theme="app"
            prefix-icon="edit-2"
            :label="$t('guideStepPreviewMenuItems.Edit guide')"
            @click="toggleArtifactModal" />
        <artifact-modal :visible="showArtifactModal">
            <template #body>
                <guides-conversational-ai-page
                    v-if="showArtifactModal"
                    :app-id="guide.appId"
                    :guide="guide"
                    :conversation-id="conversationId"
                    :is-modal="true"
                    :is-from-agent-mode="true"
                    @exit="toggleArtifactModal" />
            </template>
        </artifact-modal>
    </div>
</template>

<script>

import { PendoButton } from '@pendo/components';
import ArtifactModal from '../artifact-modal.vue';
import GuidesConversationalAiPage from '@/guides/guides-conversational-ai/guides-conversational-ai-page.vue';
import generateUniqueId from '@/utils/makeid';
import LocalAppChooser from '@/common/app-chooser/local/local-app-chooser.vue';

export default {
    name: 'GuideStepPreviewHeaderMenuItems',
    components: {
        PendoButton,
        LocalAppChooser,
        ArtifactModal,
        GuidesConversationalAiPage,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        apps: {
            type: Array,
            required: true,
        },
    },
    emits: ['app-changed'],
    data () {
        return {
            showArtifactModal: false,
            conversationId: null,
            selectedAppId: null,
        };
    },
    computed: {
        guide () {
            return this.data;
        },
    },
    created () {
        this.selectedAppId = this.apps[0].id;
    },
    methods: {
        async handleAppChange (appId) {
            if (!this.guide) return;

            this.selectedAppId = appId;

            this.$emit('app-changed', { appId, guide: this.guide });
        },
        async toggleArtifactModal () {
            const showModal = !this.showArtifactModal;

            // Generate a unique ID each time the modal opens.
            // This allows us to reference a unique guide/conversation each time, since we aren't updating/persisting
            // the guide inline artifact preview with saved changes.
            if (showModal) {
                const [{ data: { id: guideId } }, { data: { id: conversationId } }] = await Promise.all([
                    generateUniqueId(),
                    generateUniqueId(),
                ]);
                this.guide.id = guideId;
                this.conversationId = conversationId;
            }

            this.showArtifactModal = showModal;
        },
    },
};
</script>

<style scoped lang="less">
.guide-header-items {
    display: flex;
    align-items: center;
    gap: 12px;

    :deep(.pendo-multiselect__trigger) {
        min-width: 120px !important;
        max-width: 120px !important;
    }
}
</style>
